import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Achievement, AchievementDto, AchievementLatest } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getNextAchievement(): Observable<Achievement> {
        return this.httpClient.get<AchievementDto>('api/v1/library/achievement-next').pipe(map((response) => new Achievement(response)));
    }

    getLatestAchievements(): Observable<AchievementLatest[]> {
        return this.httpClient
            .get<AchievementDto[]>('api/v1/library/achievement-latest')
            .pipe(map((response) => response.map((item) => new Achievement(item))));
    }
}
